import { render, staticRenderFns } from "./InvalidUserPage.vue?vue&type=template&id=0f1cd656&scoped=true&"
import script from "./InvalidUserPage.vue?vue&type=script&lang=js&"
export * from "./InvalidUserPage.vue?vue&type=script&lang=js&"
import style0 from "./InvalidUserPage.vue?vue&type=style&index=0&id=0f1cd656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1cd656",
  null
  
)

export default component.exports